module.exports = __webpack_public_path__ + "static/media/seedling.9ebd78b7.svg";